import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';

export class MajorsApi extends BaseApi {
  public constructor (protected readonly api: AxiosInstance) {
    super();
  }

  public async listMajors (): ApiResult<{ majors: string[] }> {
    return await this.get<{ majors: string[] }>(
      '/majors',
      undefined,
      { redirectOn401: false },
    );
  }
}
